import { Injectable } from "@angular/core";
import { ConfirmationModalComponent } from "../../components/modals/confirmation-modal/confirmation-modal.component";
import { ConfirmationOptions } from "../../models/modals/confirmation-options.model";
import { ModalService } from "./modal.service";

@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalService {
  constructor(private modalService: ModalService) { }

  showConfirmationModal(options: ConfirmationOptions = {}): Promise<boolean> {
    return this.modalService.open<ConfirmationOptions, boolean>(ConfirmationModalComponent,
      {
        keyboard: false,
        backdrop: 'static',
        windowClass: 'confirmation-modal__content'
      },
      options);
  }
}